import React from 'react';
import { tour24HelpEmail, tour24PhoneNumber } from '../../data/constants';
import { formatPhoneNumber } from '../../utilities/Utils';

export const HelpEmailLink = (
    props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
) => (
    <a {...props} href={`mailto:${tour24HelpEmail}`}>
        {tour24HelpEmail}
    </a>
);

export const HelpPhoneLink = (
    props: React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
) => (
    <a {...props} href={`tel:${tour24PhoneNumber}`}>
        {formatPhoneNumber(tour24PhoneNumber)}
    </a>
);



// WEBPACK FOOTER //
// ./src/components/common/HelpLinks.tsx